import { IRoutingRuleStoreSegment } from './routingRule.interface';

export const routingRuleStoreSelector = (state: IRoutingRuleStoreSegment) => state.routingRule;
